import Record from "slotworks/model/gameplay/records/record";

export default class RainbowStacksRespinRecord extends Record {
    public multiplier: number = 1
    public wildMultiplier: number = 1;

    public awardedAmounts: number[] = [];
    public appearedSymbol: string = "";
    public jackpotSymbol: string = "";

    public remainingRespins: number = 0;
    public isRespinsComplete: boolean = false;
    public totalRespins: number = 0;
    public isComplete: boolean = false;
    public isFreespinsComplete: boolean = false;

    public isRiskGameOutcome: boolean = false; // what is this

    public inFreespins: boolean = false;
    public isJackpotWon: boolean = false;

    public triggersBonus: boolean = false;
    public totalWon: number = 0;
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/integration/revolver/schema/respin-record.ts